import _ from '@lodash';
import 'ag-grid-enterprise';
import { useEffect, useState, useRef, useCallback } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import { Button } from '@material-ui/core';
import useToast from '@fuse/hooks/useToast'
import { useDispatch, useSelector } from 'react-redux'
import { setfilterlist, setrowGroupModel, setServiceRequestId as setServiceRequestID } from '../store/filterParamsReducer';
import GeneralModal from '@fuse/components/Modal/GeneralModal';
import 'styles/ag-grid-header-style.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import { stripHtml } from 'helper/common';
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';
import { setQuickFilter } from '../../reports/store/reportViewDialogReducer';
import ServiceRequestDailog from './ServiceRequestDailog';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	cardGen: {
		width: '20%',
		height: "100%"
	},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin: '5px 5px 5px 0',
		height: '28px'
	},
	activeTab: {
		background: "rgba(107, 44, 87, 0.04);",
		borderRadius: "0",
	},
	buttonSquare: {
		borderRadius: '5px'
	},
	btn: {
		background: "#30C90A",
		width: "120px",
		borderRadius: "17px",
		color: "#fff"
	},
	icon: {
		fontSize: "18px",
		color: "#61656F",
		display: "inline-block"
	}
});

function ListView(props) {
	const table_name = "ARCHIVED_SERVICE_REQUEST";
	const classes = useStyles();
	const router = useRouter()
	const dispatch = useDispatch();
	// const rowGroupPanelShow = 'always';
	const toast = useToast(dispatch)
	const [gridApi, setGridApi] = useState(null);
	const gridRef = useRef();
	const [displayButton, setDisplayButton] = useState(false);
	const [openRestoreConfirmModal, setOpenRestoreConfirmModal] = useState(false)
	const [restoreServiceTicketId, setRestoreServiceTicketId] = useState(0)
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 330);
	const query_data = useSelector((state) => state.reportApp.reportViewDialogReducer.quick_filter);
	const service_request_id = useSelector((state) => state.ServiceRequestsApp.filterParamsReducer.service_request_id);
	const [open, setOpen] = useState(false);
	const [fullWidth, setFullWidth] = useState(true);
	const [maxWidth, setMaxWidth] = useState('lg');
	const [tabState, setTabState] = useState("asset");
	const [serviceRequestId, setServiceRequestId] = useState(null)
	const [groupByArr, setGroupByArr] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const frameworkComponents = {
		customFilter: CustomFilter,
	};
	const tableHeader = ["ticket_id", "serial_number", "location", "status", "agent_name", "subject_line", "detailed_description_of_the_issue", "created_date", "updated_date"]

	function TabButton(props) {
		const { activeClass, tab, tabState, tabStateChange, ...restProps } = props;
		const isActive = tab === tabState;
		return (
			<Button
				{...restProps}
				onClick={() => tabStateChange(tab)}
				className={restProps.className && isActive ? activeClass : ""}
			>
				{props.children}
			</Button>
		)
	}

	const handleClickOpen = (data) => {
		// setServiceRequestId(data.id)
		// setOpen(true)
		router.push(`/archive-service-tickets/${data.id}`)
	}

	function Close() {
		setOpen(false)
		setTabState('asset')
		dispatch(setServiceRequestID(null))
	}

	function TabContainer(props) {
		const { tabState, tab } = props;
		const shouldRender = tab === tabState;
		return shouldRender ? props.children : <></>
	}


	function flattenServiceRequest(data) {
		const serviceReqWithUnreadMessage = []; const serviceRequests = []
		for (const item of data) {
			const formattedObject = {
				id: item.service_request_table_id,
				ticket_id: item.ticket_id,
				subject_line: item.title,
				detailed_description_of_the_issue: stripHtml(item?.description),
				created_date: getLocalTimeFromUTC(item.created_at),
				updated_date: getLocalTimeFromUTC(item.updated_at),
				status: item.status_name,
				status_color: item.status_color,
				status_details: {
					id: item?.status_id,
					status_name: item?.status_name,
					status_color: item?.status_color
				},
				agent_name: item.agent_name,
				asset_id: item.asset_id,
				serial_number: item.serial_number,
				asset_name: item.asset_name,
				client_name: item.client_name,
				user_name: item.requestor_name,
				priority: item?.priority_name ?? '',
				priority_details: {
					id: item?.priority_id,
					priority_name: item?.priority_name ?? '',
					priority_color: item?.priority_color
				},
				location: item.location_name,
				has_unread_message: item.new_message_to_agent,
				childCount: item.childcount
			}
			if (formattedObject.has_unread_message) {
				serviceReqWithUnreadMessage.push(formattedObject)
			} else {
				serviceRequests.push(formattedObject)
			}
		}
		return [...serviceReqWithUnreadMessage, ...serviceRequests]
	}

	/** This function handles the fetching data from the server.
	It sends a POST request to the endpoint with parameters for server-side data retrieval.
	available property in params object
		{
		"startRow": 0,
		"endRow": 100,
		"rowGroupCols": [],
		"valueCols": [],
		"pivotCols": [],
		"pivotMode": false,
		"groupKeys": [],
		"filterModel": {},
		"sortModel": []
		}
	*/
	function onFetchServiceRequest(params) {
		let url = '';
		url = `/service/show-all-service-request?archived=${true}`
		// console.log(url)
		const { startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode } = params.request;
		axios.post(url, {
			dataSourceParams: {
				startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode
			}
		}).then((res) => {
			const rows = flattenServiceRequest(res.data.data.rows);
			const { lastRow } = res.data.data;
			(params.success || params.successCallback)?.({
				rowData: rows,
				rowCount: lastRow ?? rows.length,
			});
			if (rows.length === 0) gridRef.current.api.showNoRowsOverlay();
			else gridRef.current.api.hideOverlay();
		}).catch((err) => {
			console.log('error', err)
				(params.fail || params.failCallback)?.();
		})
	}

	const getChildCount = data => {
		// here child count is stored in the 'childCount' property
		return data.childCount;
	};

	/** This object represents the data source for the grid.
	*It defines a `getRows` function that is invoked by the grid to fetch rows from the server.
	*/
	const datasource = {
		getRows(params) {
			// Call the function to fetch asset data from the server.
			onFetchServiceRequest(params)
		}
	};

	const onGridReady = (params) => {
		gridRef.current = params
		// setIsGridReady(isGridReady + 1)
		setGridApi(params);
		// props.serviceRequests.forEach((list) => {
		// 	for(let [fieldName, value] of Object.entries(list)){
		// 		if(fieldName === 'archived_asset') continue;
		// 		if((value === '-' || value === '')&& fieldName === 'user_name') 
		// 			list[fieldName] = 'Unassigned'
		// 		else if(value === '' || !value || value === '')
		// 		  list[fieldName] = `No ${formatString(fieldName)}`
		// 	}
		// })
		if (router.query.report_name === undefined) {
			loadInitialState(params)
		} else {
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}

	const refreshServiceRequestList = useCallback(() => {
		if (!gridRef.current) return
		if (gridRef.current?.api?.refreshServerSideStore) {
			gridRef.current.api.refreshServerSideStore({ purge: false });
		} else if (gridRef.current?.api?.refreshServerSide) {
			gridRef.current.api.refreshServerSide();
		}
		// gridRef.current.api.refreshServerSideStore({ purge: false })
	}, [gridRef]);

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		// stop rerender to show no overlay text
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
	}

	function getReport(event) {
		const { report_name } = router.query;
		// const table_name = "service request";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const row_model = JSON.parse(results.data.data.row_model);
				event?.api.applyColumnState({ state: row_model });
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		axios
			.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then((results) => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data.filter);
					gridRef.current = { ...gridRef.current, filterModelArr: filter }
					params?.api.applyColumnState({ state: order });
					params?.api.setFilterModel(filter);
				}
			})
			.catch((err) => {
				console.log(err);
			}).finally(() => {
				params?.api.setGridOption('serverSideDatasource', datasource);
			});
	}
	function onSortChanged(params) {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			dispatch(setrowGroupModel(rows));
			saveView(rows);
		}
	}

	function saveView(rows, filter, filterModelArr = null) {
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filterModelArr ?? filter),
				table_name
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	const onColumnMoved = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
		}
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
		}
	}

	function onColumnVisible(params) {
		const rows = params.api.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				++total_hidden_columns;
			}
		});
		if (total_hidden_columns < total_no_of_columns) {
			if (router.query.report_name === undefined) {
				saveView(rows);
			}
		}
	}

	function onColumnRowGroupChanged(event) {
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);

		if (router.query.report_name === undefined) {
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if (first_row.colId !== "ag-Grid-AutoColumn") {
				dispatch(setrowGroupModel(rows));
				saveView(rows);
			} else {
				dispatch(setrowGroupModel(rows));
				// saveView(rows);
			}
		}
	}

	const onRangeSelectionChanged = (params) => {

		let columnCount = 0;
		let startRowIndex = 0;
		let endRowIndex = 0;

		const rows = params.api.getCellRanges();

		if (rows.length != 0) {
			columnCount = params.api.getCellRanges()[0].columns.length;
			startRowIndex = params.api.getCellRanges()[0].startRow.rowIndex;
			endRowIndex = params.api.getCellRanges()[0].endRow.rowIndex;
		}

		if (columnCount > 1 || startRowIndex != endRowIndex) {
			setDisplayButton(true);
		} else {
			setDisplayButton(false);
		}
	}

	const handleConfirmRestore = () => {
		if (restoreServiceTicketId !== 0) {
			axios.post(`/service/restore-service-request/${restoreServiceTicketId}`).then((res) => {
				refreshServiceRequestList()
				toast.success('Service ticket restored successfully.')
				setOpenRestoreConfirmModal(false)
			}).catch(err => {
				console.log('err', err);
				toast.error(err.response.data.message)
			})
		}

	}
	const handleCloseRestoreModal = () => {
		setRestoreServiceTicketId(0)
		setOpenRestoreConfirmModal(false)
	}

	const handleRestore = (id) => {
		setRestoreServiceTicketId(id)
		setOpenRestoreConfirmModal(true)
	}

	const generateHeaderLabel = (header) => {
		if (header === 'accessory_category_id') {
			return 'Accessory Category Name'
		} if (header === 'manufacturer_id') {
			return 'Manufacturer Name'
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	useEffect(() => {
		gridRef?.current?.api?.setQuickFilter(query_data);
	}, [query_data])

	useEffect(() => {
		if (service_request_id) {
			setOpen(true)
			setServiceRequestId(service_request_id)
		}
	}, [service_request_id]);

	useEffect(() => {
		// onGridReady()
		return () => {
			dispatch(setQuickFilter(null))
		}
	}, [props.serviceRequests])

	function redirectToAssetProfile(event) {
		router.push(`/${event.data.archived_asset ? 'archived-assets' : 'assets-list'}/${event.data.asset_id}`);
	}

	function handleHideColumnDropDownDesign() {
		return {
			display: "inline-flex",
			alignItems: "center",
			justifyContent: "space-between",
			border: "1px solid #000000",
			borderRadius: "20px",
			padding: "3px 10px",
			backgroundColor: "#ffffff",
			lineHeight: "1",
			height: "28px",
			position: "relative",
			cursor: "pointer",
			fontFamily: '"Inter", sans-serif',
			fontSize: "13px",
			fontWeight: 500,
		};
	}

	return (
		<>
			<AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				tableName="Archived Service Tickets"
				displayTableName="Archived Service Tickets"
			/>
			<div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '11px'
				}}
			>
				<AgGridReact
					rowModelType='serverSide'
					serverSideStoreType="partial"
					ref={gridRef}
					theme="legacy"
					suppressRowClickSelection
					onGridReady={onGridReady}
					animateRows
					rowData={props.serviceRequests}
					rowHeight={30}
					headerHeight={44}
					onRowClicked={() => {
					}}
					defaultColDef={{
						enableRowGroup: true,
						resizable: true
					}}
					// no rows overlay 
					overlayNoRowsTemplate="<span>No Result Found</span>"

					// Row Grouping conditions
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}

					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={onColumnVisible}
					onSortChanged={onSortChanged}
					groupHeaderHeight={1}
					// headerHeight = {15}
					floatingFiltersHeight={40}
					components={frameworkComponents}
					// status bar enabled on range selection
					enableRangeSelection
					statusBar={{
						statusPanels: [
							{
								statusPanel: 'agAggregationComponent'
							},
						],
					}}

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged={onRangeSelectionChanged}

					onFilterChanged={onFilterChanged}

					// on column group changed
					onColumnRowGroupChanged={onColumnRowGroupChanged}

					pagination
					getChildCount={getChildCount}
					columnDefs={[
						{
							lockPosition: true,
							rowSelection: "single",
							width: 100,
							minWidth: 100,
							maxWidth: 100,
							suppressSizeToFit: true,
							headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
							pinned: 'right',
							className: "action_field",
							lockPinned: true,
							cellRenderer: ({ data }) => {
								if (data) {
									return (
										<>
											{props.viewServiceRequestPermission && <Tooltip id="view" title="View" placement="top">
												{/* <Icon onClick={() => handleClickOpen(data)} fontSize='small' style={{color: '#1d2939',paddingBottom: '3px',paddingRight:'30px',fontSize:'15px',cursor:'pointer'}} >visibility</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-eye" onClick={() => handleClickOpen(data)} />
											</Tooltip>}

											{props.deleteServiceRequestPermission && <Tooltip id="unarchive" title="Restore" placement="top">
												{/* <Icon onClick={() => {handleRestore(data.id)}} style={{color: '#1d2939',paddingBottom: '3px',paddingRight:'30px',fontSize:'15px',cursor:'pointer'}}>unarchive_outlined</Icon> */}
												<i style={{ color: '#1D2939', fontSize: '20px', padding: '0 6px', cursor: 'pointer' }} className="ti ti-reload" onClick={() => handleRestore(data.id)} />
											</Tooltip>}
										</>
									)
								}
								return (<></>)

							}
						},
						...tableHeader.map(header => {
							if (header === 'status') {
								return {
									field: header,
									key: header,
									minWidth: 230,
									cellEditorPopup: true,
									suppressSizeToFit: true,
									// cellEditor="agRichSelectCellEditor"
									cellEditor: 'customDropdownEditor',
									headerComponent: (prop) => (CustomFilter(prop, header, gridRef)),
									sortable: true,

									// floatingFilter
									headerName: generateHeaderLabel(header),
									filter: "agTextColumnFilter",
									editable: false,
									cellRenderer: (event) => {
										if (event.colDef.field === "status") {
											return (
												<span
													style={handleHideColumnDropDownDesign()}>
													<span
														style={{
															height: "10px",
															width: "10px",
															marginTop: "2px",
															borderRadius: "50%",
															display: "inline-block",
															// backgroundColor: event.data?.asset_status_color?.code
															backgroundColor:
																event.value?.split(",")[1] ??
																event.data?.status_details?.status_color?.code,
														}}
													/>
													{/* <span style={{height: '10px',width: '10px',backgroundColor: '#bbb',borderRadius: '50%',display:'inline-block'}}></span> */}
													{/* <span style={{marginLeft: '5px'}}>{event.data?.status_value?.status_name}</span> */}
													<span style={{ marginLeft: "5px", marginRight: '14px', fontSize: '12px', fontWeight: '500', color: 'black', fontFamily: '"Inter", sans-serif', }}>
														{event.value?.split(",")[0]}
													</span>
												</span>
											);
										} if (
											event.colDef.headerName === "Group" &&
											event.node.field === "status"
										) {
											return (
												<>
													<span>{event.value}</span>
												</>
											);
										}
										return (
											<>
												<span>{event.value}</span>
											</>
										);
									}
								}
							}

							if (header === 'detailed_description_of_the_issue') {
								return {
									field: header,
									key: header,
									minWidth: 400,
									suppressSizeToFit: true,
									headerName: generateHeaderLabel(header),
									sortable: true,
									flex: 1,
									headerComponent: (prop) => (CustomFilter(prop, header, gridRef)),
									filter: "text"
								}
							}
							if (header === 'serial_number') {
								return {
									field: header,
									key: header,
									suppressSizeToFit: true,
									headerName: generateHeaderLabel(header),
									sortable: true,
									headerComponent: (prop) => (CustomFilter(prop, header, gridRef)),
									filter: "agTextColumnFilter",
									flex: 1,
									minWidth: 200,
									cellRenderer: (event) => {
										if (event.value === "No Serial Number") {
											return (<span>{event.value}</span>)
										}
										return (<a
											style={{
												height: '10px',
												width: '10px',
												color: 'black',
												cursor: 'pointer',
												marginTop: '2px',
												borderRadius: '50%',
												display: 'inline-block',
											}}
											onClick={() => redirectToAssetProfile(event)}
											variant="subtitle1"
										>
											<span>{event.value}</span>
										</a>)
									}
								}
							}
							return {
								field: header,
								key: header,
								suppressSizeToFit: true,
								headerName: generateHeaderLabel(header),
								sortable: true,
								flex: 1,
								minWidth: 200,
								headerComponent: (prop) => (CustomFilter(prop, header, gridRef)),
								filter: "text"
							}
						})
					]}
				/>
			</div>

			{
				openRestoreConfirmModal && (
					<GeneralModal
						open={openRestoreConfirmModal}
						title="Are you sure to restore service ticket?"
						text={
							<h4>
								Are you sure to Restore this Service Ticket?
								{/* <b>{modalData.ticket_number}</b>? */}
							</h4>
						}
						detailMessage="Your ticket will be moved to service tickets if you proceed"
						handleClose={handleCloseRestoreModal}
						handleConfirm={handleConfirmRestore}
						actionButtonName="Yes, Proceed!"
					/>
				)
			}

			{open && <ServiceRequestDailog
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={open}
				setOpen={setOpen}
				Close={Close}
				classes={classes}
				TabButton={TabButton}
				tabState={tabState}
				setTabState={setTabState}
				TabContainer={TabContainer}
				serviceRequestId={serviceRequestId}
			/>}
		</>
	);
}

export default ListView